<template>
	<div id="start-page">
		<div id="white-start">
			<div id="hero-image">
				<img :src="baseUrl + landingStartData[0].backgroundImage.url"/>
			</div>
			<LandingHeaderBar isMain="true" @scrollFeature="scroll('feature')" @scrollProduct="scroll('product')" class="overlap"/>
			<LandingIntroduction class="overlap" :headline="landingStartData[0].title" :head-text="landingStartData[0].headline"/>
			<CompetencesGrid />
		</div>
		<FeatureMainContainer id="feature"/>
		<div id="product-container">
			<LandingProduct id="product"/>
		</div>
	</div>
</template>

<script>

import LandingIntroduction from './landing-introduction/Landing-Introduction.vue'
import CompetencesGrid from './landing-competences/Competences-Grid.vue'
import FeatureMainContainer from './landing-features/Feature-Main-Container.vue'
import LandingProduct from './landing-product/Landing-Product.vue'

import LandingHeaderBar from '../shared-views/landing-header-bar/Landing-Header-Bar.vue'
import JsonProvider from '../../services/DataService.js';
import {configData} from '../../services/DataService.js';

	export default {
		name: 'LandingStartComponent',
		components: {
			LandingIntroduction,
			CompetencesGrid,
			FeatureMainContainer,
			LandingProduct,

			LandingHeaderBar
		},

		data:
			function() {
			return {
				heroImage: require('../../assets/Bilder/VDP Stadt.jpg'),
				landingStartData: [],
			}
		},
		
		methods: {
			scroll(ref) {
				var el = document.getElementById(ref);
				var rect = el.getBoundingClientRect();

				
				if('scrollBehavior' in document.documentElement.style) {
				window.scrollTo({top: rect.top, left: 0, behavior: "smooth"});
				} else {
					window.scrollTo(rect.top, 0);
				}
			}
		},
		
		created: async function() {
			var jsonGetter = new JsonProvider();
			this.landingStartData = await jsonGetter.fetchJsonObject('general-infos');
			this.baseUrl = configData.baseUrl.data.baseUrl;
			
			var features = await jsonGetter.fetchJsonObject('features');

			if(features.length % 2 == 1) {
			
			var product = document.getElementById("product-container");
			product.style.backgroundColor = "white";
			
			if(window.innerWidth > 767) {
				var buttons = product.getElementsByTagName("button");
					for (var i = 0; i < buttons.length; i++) {
						buttons[i].style.background = '#e5e5e5';
						buttons[i].style.borderColor = '#e5e5e5';
					}
				}
			}
			
			
		}
	}

</script>

<style scoped>
	#hero-image {
		position: absolute;
		width: 100%;
		top: 0;
		right: 0;
		max-height: 660px;
		overflow: hidden;
		text-align: center;
		white-space: nowrap;
		height: 660px;
	}

	#product-container {
		padding-top: 1em;
	}
	img {
		width:100%;
		vertical-align: middle;
	}
	
	#white-start {
		background-color: white;
	}
	
	@media (min-width: 1200px) {
	img {
		transform: translateY(-25%);
	}
	}


</style>
